import { JWTPayload } from 'jose';
import type { AssetronUserId, FirebasePrincipalId } from '../types/identity';

export type IdentityJwtPayload = JWTPayload & {
  assetron_user_id?: string;
  user_id?: string;
  sub?: string;
  uid?: string;
};

const normalizeNonEmptyString = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  return trimmed;
};

export const getAssetronUserId = (value: unknown): AssetronUserId | null => {
  const normalized = normalizeNonEmptyString(value);
  if (!normalized) {
    return null;
  }

  return normalized as AssetronUserId;
};

export const getFirebasePrincipalId = (
  value: unknown,
): FirebasePrincipalId | null => {
  const normalized = normalizeNonEmptyString(value);
  if (!normalized) {
    return null;
  }

  return normalized as FirebasePrincipalId;
};

export const getAssetronUserIdFromJwtPayload = (
  payload?: IdentityJwtPayload | null,
): AssetronUserId | null => getAssetronUserId(payload?.assetron_user_id);

export const getFirebasePrincipalIdFromJwtPayload = (
  payload?: IdentityJwtPayload | null,
): FirebasePrincipalId | null =>
  getFirebasePrincipalId(payload?.user_id ?? payload?.sub ?? payload?.uid);
